// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Page layout ─────────────────────────────────────────────────────── */
.blog-list-page {
  min-height: 100vh;
  background: #f9f9f9;
  font-family: 'Inter', 'DM Sans', sans-serif;
}

/* ─── Header ──────────────────────────────────────────────────────────── */
.blog-list-page__header {
  background: #1a1a2e;
  color: #fff;
  padding: 64px 24px 48px;
  text-align: center;
}

.blog-list-page__header-inner {
  max-width: 640px;
  margin: 0 auto;
}

.blog-list-page__eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: #a5b4fc;
  margin: 0 0 10px;
}

.blog-list-page__heading {
  font-size: 40px;
  font-weight: 800;
  margin: 0 0 12px;
  line-height: 1.15;
}

.blog-list-page__sub {
  font-size: 16px;
  color: #cbd5e1;
  margin: 0 0 24px;
  line-height: 1.6;
}

.blog-list-page__header-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.blog-list-page__admin-link,
.blog-list-page__home-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity .2s;
}

.blog-list-page__admin-link {
  background: #4f46e5;
  color: #fff;
}

.blog-list-page__home-link {
  background: rgba(255,255,255,.12);
  color: #fff;
}

.blog-list-page__admin-link:hover,
.blog-list-page__home-link:hover {
  opacity: .85;
}

/* ─── Controls ────────────────────────────────────────────────────────── */
.blog-list-page__controls {
  max-width: 1100px;
  margin: 32px auto 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.blog-list-page__search-wrap {
  position: relative;
  flex-shrink: 0;
}

.blog-list-page__search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 15px;
}

.blog-list-page__search {
  padding: 10px 14px 10px 36px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  background: #fff;
  width: 220px;
  transition: border-color .2s;
}
.blog-list-page__search:focus { border-color: #4f46e5; }

.blog-list-page__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.blog-list-page__tag-btn {
  padding: 8px 16px;
  border-radius: 20px;
  border: 1.5px solid #e5e7eb;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: background .15s, color .15s, border-color .15s;
}
.blog-list-page__tag-btn.active,
.blog-list-page__tag-btn:hover {
  background: #4f46e5;
  color: #fff;
  border-color: #4f46e5;
}

/* ─── Grid ────────────────────────────────────────────────────────────── */
.blog-list-page__grid {
  max-width: 1100px;
  margin: 28px auto 48px;
  padding: 0 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
}

/* ─── Blog card ───────────────────────────────────────────────────────── */
.blog-card {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,.07);
  transition: transform .2s, box-shadow .2s;
}
.blog-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(0,0,0,.12);
}

.blog-card__img-wrap {
  position: relative;
  overflow: hidden;
  aspect-ratio: 16 / 9;
}

.blog-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .35s;
}
.blog-card:hover .blog-card__img { transform: scale(1.05); }

.blog-card__img-placeholder {
  width: 100%;
  height: 100%;
  background: #f0f0ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: #c4b5fd;
}

.blog-card__overlay {
  position: absolute;
  inset: 0;
  background: rgba(79, 70, 229, .55);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .25s;
}
.blog-card:hover .blog-card__overlay { opacity: 1; }

.blog-card__read-btn {
  padding: 10px 22px;
  background: #fff;
  color: #4f46e5;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.blog-card__body { padding: 20px; }

.blog-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 6px;
}

.blog-card__tags { display: flex; flex-wrap: wrap; gap: 4px; }
.blog-card__tag {
  background: #ede9fe;
  color: #4f46e5;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.blog-card__date {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #9ca3af;
  white-space: nowrap;
}

.blog-card__title {
  font-size: 16px;
  font-weight: 700;
  color: #111;
  margin: 0 0 8px;
  line-height: 1.4;
}

.blog-card__excerpt {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}

/* ─── Empty state ─────────────────────────────────────────────────────── */
.blog-list-page__empty {
  text-align: center;
  padding: 80px 24px;
  color: #9ca3af;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.blog-list-page__empty p { font-size: 15px; margin: 10px 0 0; }

/* ─── Responsive ──────────────────────────────────────────────────────── */
@media (max-width: 600px) {
  .blog-list-page__heading { font-size: 28px; }
  .blog-list-page__grid { grid-template-columns: 1fr; }
  .blog-list-page__controls { flex-direction: column; align-items: stretch; }
  .blog-list-page__search { width: 100%; }
}`, "",{"version":3,"sources":["webpack://./src/pages/BlogList.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,4EAA4E;AAC5E;EACE,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA,4EAA4E;AAC5E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;AACA,gCAAgC,qBAAqB,EAAE;;AAEvD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,4EAA4E;AAC5E;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,yCAAyC;AAC3C;AACA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;AACA,mCAAmC,sBAAsB,EAAE;;AAE3D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;AAC1B;AACA,uCAAuC,UAAU,EAAE;;AAEnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB,aAAa,EAAE;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA,mBAAmB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC7D;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA,2BAA2B,eAAe,EAAE,gBAAgB,EAAE;;AAE9D,4EAA4E;AAC5E;EACE,2BAA2B,eAAe,EAAE;EAC5C,wBAAwB,0BAA0B,EAAE;EACpD,4BAA4B,sBAAsB,EAAE,oBAAoB,EAAE;EAC1E,0BAA0B,WAAW,EAAE;AACzC","sourcesContent":["/* ─── Page layout ─────────────────────────────────────────────────────── */\n.blog-list-page {\n  min-height: 100vh;\n  background: #f9f9f9;\n  font-family: 'Inter', 'DM Sans', sans-serif;\n}\n\n/* ─── Header ──────────────────────────────────────────────────────────── */\n.blog-list-page__header {\n  background: #1a1a2e;\n  color: #fff;\n  padding: 64px 24px 48px;\n  text-align: center;\n}\n\n.blog-list-page__header-inner {\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.blog-list-page__eyebrow {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: .1em;\n  text-transform: uppercase;\n  color: #a5b4fc;\n  margin: 0 0 10px;\n}\n\n.blog-list-page__heading {\n  font-size: 40px;\n  font-weight: 800;\n  margin: 0 0 12px;\n  line-height: 1.15;\n}\n\n.blog-list-page__sub {\n  font-size: 16px;\n  color: #cbd5e1;\n  margin: 0 0 24px;\n  line-height: 1.6;\n}\n\n.blog-list-page__header-links {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.blog-list-page__admin-link,\n.blog-list-page__home-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: opacity .2s;\n}\n\n.blog-list-page__admin-link {\n  background: #4f46e5;\n  color: #fff;\n}\n\n.blog-list-page__home-link {\n  background: rgba(255,255,255,.12);\n  color: #fff;\n}\n\n.blog-list-page__admin-link:hover,\n.blog-list-page__home-link:hover {\n  opacity: .85;\n}\n\n/* ─── Controls ────────────────────────────────────────────────────────── */\n.blog-list-page__controls {\n  max-width: 1100px;\n  margin: 32px auto 0;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.blog-list-page__search-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.blog-list-page__search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 15px;\n}\n\n.blog-list-page__search {\n  padding: 10px 14px 10px 36px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  background: #fff;\n  width: 220px;\n  transition: border-color .2s;\n}\n.blog-list-page__search:focus { border-color: #4f46e5; }\n\n.blog-list-page__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.blog-list-page__tag-btn {\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1.5px solid #e5e7eb;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  transition: background .15s, color .15s, border-color .15s;\n}\n.blog-list-page__tag-btn.active,\n.blog-list-page__tag-btn:hover {\n  background: #4f46e5;\n  color: #fff;\n  border-color: #4f46e5;\n}\n\n/* ─── Grid ────────────────────────────────────────────────────────────── */\n.blog-list-page__grid {\n  max-width: 1100px;\n  margin: 28px auto 48px;\n  padding: 0 24px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 24px;\n}\n\n/* ─── Blog card ───────────────────────────────────────────────────────── */\n.blog-card {\n  background: #fff;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 12px rgba(0,0,0,.07);\n  transition: transform .2s, box-shadow .2s;\n}\n.blog-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 28px rgba(0,0,0,.12);\n}\n\n.blog-card__img-wrap {\n  position: relative;\n  overflow: hidden;\n  aspect-ratio: 16 / 9;\n}\n\n.blog-card__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform .35s;\n}\n.blog-card:hover .blog-card__img { transform: scale(1.05); }\n\n.blog-card__img-placeholder {\n  width: 100%;\n  height: 100%;\n  background: #f0f0ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 36px;\n  color: #c4b5fd;\n}\n\n.blog-card__overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(79, 70, 229, .55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity .25s;\n}\n.blog-card:hover .blog-card__overlay { opacity: 1; }\n\n.blog-card__read-btn {\n  padding: 10px 22px;\n  background: #fff;\n  color: #4f46e5;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.blog-card__body { padding: 20px; }\n\n.blog-card__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.blog-card__tags { display: flex; flex-wrap: wrap; gap: 4px; }\n.blog-card__tag {\n  background: #ede9fe;\n  color: #4f46e5;\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.blog-card__date {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #9ca3af;\n  white-space: nowrap;\n}\n\n.blog-card__title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111;\n  margin: 0 0 8px;\n  line-height: 1.4;\n}\n\n.blog-card__excerpt {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* ─── Empty state ─────────────────────────────────────────────────────── */\n.blog-list-page__empty {\n  text-align: center;\n  padding: 80px 24px;\n  color: #9ca3af;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.blog-list-page__empty p { font-size: 15px; margin: 10px 0 0; }\n\n/* ─── Responsive ──────────────────────────────────────────────────────── */\n@media (max-width: 600px) {\n  .blog-list-page__heading { font-size: 28px; }\n  .blog-list-page__grid { grid-template-columns: 1fr; }\n  .blog-list-page__controls { flex-direction: column; align-items: stretch; }\n  .blog-list-page__search { width: 100%; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
